



















import { Component, Prop } from "vue-property-decorator";
import JConfTableV01 from "@share/common/tables/j-conf-table/virtual/JConfTable-V01.vue";
import TableLimitMessage from "@share/participants-import/components/table-limit-message/TableLimitMessage.vue";

import { HeaderSetting, TableSettings } from "@share/common/tables/j-conf-table/types";
import { defaultProfileFields, ProfileField } from "../../../../../types/ProfileField";
import ImportStep from "../ImportStep.vue";
import { getHeaderSettingsByFields } from "@share/participants-import/helpers/headerSettings";

@Component({ components: { JConfTableV01, TableLimitMessage } })

export default class Step2Preview extends ImportStep {
    @Prop({ required: true }) previewItems: Record<string, string>[];
    @Prop() limit: number;
    @Prop() total: number;

    tableSettings: TableSettings = {
        minRowHeight: 76
    }

    get fields () {
        return this.headerSettings.map(setting => setting.name);
    }

    get headerSettings (): HeaderSetting[] {
        const language = this.$store.state.session?.language ?? 'en';

        const profileParams = this.$store.getters['events/selectedEventViewParam']('profile', null);
        let fields: ProfileField[] = [{
            title: {
                en: "#",
                ru: "№",
                uk: "№"
            },
            name: "__rowNum__",
            type: "input",
        }];

        if (profileParams?.fields) {
            fields = [...fields, ...profileParams.fields];
        }
        else {
            fields = [...fields, ...defaultProfileFields];
        }

        return getHeaderSettingsByFields(fields, language);
    }
}

